// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NakQ","label":"styles_label__3l6AU"};